var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Animated, View, StyleSheet, Easing } from 'react-native';
import R from '../../core-res/R';
import { withTheme } from '../../theme';
const ANIMATION_START_DELAY = R.animation.timing.instant;
const SCALE_MIN = 1 / 3;
const SCALE_MAX = 1;
const OPACITY_MIN = R.opacity.washedOut();
const OPACITY_MAX = 1;
const DOT_SIZE = 12;
const animationConfig = {
    duration: R.animation.timing.normal,
    easing: Easing.inOut(Easing.ease),
};
function createAnimations(count) {
    // We can't use fill directly with new Animated.Value because entire array values
    // will references the same instance. That's why we fill it first with empty string
    // to remove hole in array, and map over them to Animated.Value
    return new Array(count).fill('').map(() => new Animated.Value(SCALE_MIN));
}
function terminateAnimations(animations) {
    // Stopping animation is not enough because Animated.View still
    // references old Animated.Value, that's why we mutate them manually
    // to initial Animated.Value
    animations.forEach(v => v.setValue(SCALE_MIN));
}
class LoadingIndicator extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            animations: createAnimations(this.props.count),
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.count !== prevState.animations.length) {
            terminateAnimations(prevState.animations);
            return { animations: createAnimations(nextProps.count) };
        }
        return null;
    }
    componentDidMount() {
        this.createAnimationLoop();
        if (this.props.autoplay) {
            this.animation.start();
        }
    }
    createAnimationLoop() {
        this.animation = Animated.loop(Animated.stagger(ANIMATION_START_DELAY, this.state.animations.map(value => {
            return Animated.sequence([
                Animated.timing(value, Object.assign({ toValue: SCALE_MAX }, animationConfig)),
                Animated.timing(value, Object.assign({ toValue: SCALE_MIN }, animationConfig)),
            ]);
        })));
    }
    // Provide imperative access via ref to start and stop animation loop manually
    start() {
        // We need to recreate animation loops because restarting stopped animation
        // is not possible with just this.animation.start() call
        this.createAnimationLoop();
        // Because we have new instance of animation sequence, we can run .start
        // to trigger both start and restart event
        this.animation.start();
    }
    stop() {
        this.animation.stop();
        terminateAnimations(this.state.animations);
    }
    render() {
        const _a = this.props, { theme, style } = _a, props = __rest(_a, ["theme", "style"]);
        const color = this.props.color || theme.tintPrimary;
        return (<View {...props} style={[styles.container, style]}>
        {this.state.animations.map((value, index) => (<Animated.View key={index} style={[
            styles.dot,
            {
                backgroundColor: color,
                transform: [{ scale: value }],
                opacity: value.interpolate({
                    inputRange: [SCALE_MIN, SCALE_MAX],
                    outputRange: [OPACITY_MIN, OPACITY_MAX],
                }),
            },
        ]}/>))}
      </View>);
    }
}
LoadingIndicator.defaultProps = {
    count: 3,
    autoplay: true,
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    dot: {
        height: DOT_SIZE,
        width: DOT_SIZE,
        borderRadius: DOT_SIZE / 2,
        marginHorizontal: (12 - DOT_SIZE) / 2,
    },
});
export default withTheme(LoadingIndicator);
